import "./App.css";
import AddProduct from "./Components/product/AddProduct";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { Box } from "@mui/material";
import AddCategory from "./Components/category/AddCategory";
import Banner from "./Components/banner/Banner";
import UserList from "./Components/UserList";
import Sidebar from "./Components/sidebar/Sidebar";
import ProductList from "./Components/product/ProductList";
import ConfigScreen from "./Components/screens/Config";
import Orders from "./Components/screens/Orders";
import More from "./Components/screens/More";
import Home from "./Components/screens/Home";
import MyAppBar from "./Components/MyAppBar";
import MiniDrawer from "./Components/MiniDrawer";

function App() {
  return (
    <div className="App">
      <Router>
        <MiniDrawer />
      </Router>
      {/* <Box sx={{ display: "flex" }}>
        <Router>
          <Sidebar />
          <Box sx={{ flexGrow: 1 }}>
            <MyAppBar />
            <Box sx={{ ml: 5, mr: 5 }}>
              <Switch>
                <Route exact path="/">
                  <Redirect to="/home" />
                </Route>
                <Route exact path="/home">
                  <Home />
                </Route>
                <Route exact path="/app/banner">
                  <Banner />
                </Route>
                <Route exact path="/app/feed">
                  Feature Coming Soon
                </Route>
                <Route exact path="/product/view">
                  <ProductList />
                </Route>
                <Route exact path="/product/add">
                  <AddProduct />
                </Route>
                <Route exact path="/users">
                  <UserList />
                </Route>
                <Route exact path="/categories">
                  <AddCategory />
                </Route>
                <Route exact path="/config">
                  <ConfigScreen />
                </Route>
                <Route exact path="/orders">
                  <Orders />
                </Route>
                <Route exact path="/more">
                  <More />
                </Route>
              </Switch>
            </Box>
          </Box>
        </Router>
      </Box> */}
    </div>
  );
}

export default App;
